/**
 * Assisted WhatsApp send (click-to-chat). Premise never sends on its own — it
 * opens WhatsApp with the tenant and a pre-composed message filled in, so the
 * owner taps Send from their own number. No WhatsApp API, no cost, fully within
 * WhatsApp's rules. See the "one-tap assisted send" decision.
 */

/** Build a wa.me deep link to a tenant with a pre-filled message, or null if no phone. */
export function waLink(phone: string | null | undefined, message: string): string | null {
  const digits = (phone ?? '').replace(/[^\d]/g, '');
  if (!digits) return null;
  return `https://wa.me/${digits}?text=${encodeURIComponent(message)}`;
}

/** Open the tenant's WhatsApp chat with the message ready to send. */
export function openWhatsApp(phone: string | null | undefined, message: string): boolean {
  const url = waLink(phone, message);
  if (!url) return false;
  window.open(url, '_blank', 'noopener');
  return true;
}

/** A polite rent reminder — softer when merely due, firmer once overdue. */
export function rentReminder(opts: {
  property: string;
  tenant: string;
  amount: string; // already formatted, e.g. "₹90,000"
  dueLabel: string; // e.g. "5 Apr"
  overdue: boolean;
}): string {
  const { property, tenant, amount, dueLabel, overdue } = opts;
  if (overdue) {
    return `Hi ${tenant}, a gentle reminder from ${property}: rent ${amount} was due on ${dueLabel} and is still showing open. Please arrange it when you can. Reply here if anything's off. Thank you.`;
  }
  return `Hi ${tenant}, a reminder from ${property}: rent ${amount} is due on ${dueLabel}. Pay anytime. Reply here if anything's off. Thank you.`;
}
